module.exports = _.isSymbol;